import React from "react";
import { HintView } from "lib/components/index";

const Hint = ({ isAccommodation }) => (
  <HintView.Hint>
    <h3>{I18n.t("papp.products.EditProductView.StepLocation.hint.p1")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepLocation.hint.p2")}</p>

    <p>{I18n.t("papp.products.EditProductView.StepLocation.hint.p3")}</p>

    {!isAccommodation && (
      <div>
        <h3>{I18n.t("papp.products.EditProductView.StepLocation.hint.p4")}</h3>
        <p>{I18n.t("papp.products.EditProductView.StepLocation.hint.p5")}</p>

        <p>{I18n.t("papp.products.EditProductView.StepLocation.hint.p6")}</p>

        <p>{I18n.t("papp.products.EditProductView.StepLocation.hint.p7")}</p>

        <p>{I18n.t("papp.products.EditProductView.StepLocation.hint.p8")}</p>

        <h3>{I18n.t("papp.products.EditProductView.StepLocation.hint.p9")}</h3>
        <p>{I18n.t("papp.products.EditProductView.StepLocation.hint.p10")}</p>
      </div>
    )}
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepLocation/StepLocationHint.jsx